import React, { useMemo } from 'react';
import { StatCard } from '../ui';
import { StatCardData } from '../../types';
import { WarningSummaryVo } from '../../api/types';
import styles from '../../styles/components/layout/statistics-grid.module.css';

interface StatisticsGridProps {
  stats: WarningSummaryVo | null;
  loading: boolean;
  error: string | null;
}

const StatisticsGrid: React.FC<StatisticsGridProps> = ({ stats, loading, error }) => {
  // 转换为卡片数据格式
  const statCards = useMemo(() => {
    if (!stats) return [];

    return [
      { id: 'students', label: '就餐学生', count: stats.student, unit: '人' },
      { id: 'teachers', label: '教师员工', count: stats.teacher, unit: '人' },
      { id: 'workers', label: '从业人员', count: stats.staff, unit: '人' },
      { id: 'others', label: '其他人员', count: stats.other, unit: '人' },
      { id: 'suppliers', label: '食材商', count: stats.foodSupplier, unit: '家' },
      { id: 'fuel', label: '燃料商', count: stats.fuelSupplier, unit: '家' },
      { id: 'finance', label: '厨废商', count: stats.kitchenWasteSupplier, unit: '家' },
    ] as StatCardData[];
  }, [stats]);

  if (loading) {
    return <div className={styles.loading}>加载中...</div>;
  }

  if (error) {
    return <div className={styles.error}>加载失败: {error}</div>;
  }

  return (
    <section className={styles.statisticsGrid}>
      {statCards.map((card) => (
        <StatCard key={card.id} data={card} />
      ))}
    </section>
  );
};

export default StatisticsGrid;